module.exports = __webpack_public_path__ + "static/media/coffee-stain.cddd3fbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coffee-stain.png
// module id = 350
// module chunks = 0